type Props = {
  src: string
  alt?: string
}

export function DocImage({ src, alt }: Props) {
  return (
    <img
      src={`/docs/images/${src}`}
      alt={alt ?? ''}
      className="rounded-lg border border-border max-w-full my-4"
      loading="lazy"
      onError={(e) => {
        const target = e.currentTarget
        target.style.display = 'none'
        const fallback = target.nextElementSibling as HTMLElement | null
        if (fallback) fallback.style.display = 'block'
      }}
    />
  )
}

export function DocImagePlaceholder({ alt }: { alt: string }) {
  return (
    <span
      className="hidden"
      data-placeholder
    >
      [{alt}]
    </span>
  )
}
